import { ReactElement, useEffect, useState } from "react";
import { ISelectedNode, Modules } from "../../../types";
import { IDashboard } from "../types";
import {
  Button, CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List, ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useLazyFetch } from "../../../system/useFetch";
import { Dashboard } from "@mui/icons-material";
import { getPalette } from "../../../configuration/configuration";

interface IProps {
  open: boolean;
  onClose: () => void;
  selectedNode: ISelectedNode;
  onOpenDashboard: (dashboard: IDashboard) => void;
}

const OpenDashboard = ({ open, onClose, selectedNode, onOpenDashboard }: IProps): ReactElement => {
  const [ selectedDashboard, setSelectedDashboard ] = useState<IDashboard | null>(null);
  const [ getDashboards, { data }] = useLazyFetch<IDashboard[]>(true);
  const [ dashboards, setDashboards ] = useState<IDashboard[] | null>(null);

  useEffect(() => {
    if (open) {
      getDashboards({
        module: "dashboard",
        query: "getDashboards",
        payload: {
          nodeID: selectedNode.nodeID,
          nodeType: selectedNode.type,
          moduleID: Modules.DASHBOARD_RT,
          rtModule: true
        }
      });
    }
  }, [ open, getDashboards ]);

  useEffect(() => {
    if (data) {
      setDashboards(data);
    }
  }, [ data ]);

  const onAccept = () => {
    if (selectedDashboard) {
      onClose();
      onOpenDashboard(selectedDashboard);
    }
  };

  const onDoubleClick = (dashboard: IDashboard) => {
    onClose();
    onOpenDashboard(dashboard);
  };

  const onCancel = () => {
    onClose();
    setSelectedDashboard(null);
  };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={open} maxWidth="lg">
      <DialogTitle id="customized-dialog-title">
        Open Layout
      </DialogTitle>

      <DialogContent dividers={true}>
        { !dashboards &&
          <div className="display-flex-row justify-content-center align-items-center p-2">
            <CircularProgress className=""/>
          </div>
        }

        { dashboards &&
          <List className="m-0" style={{ maxHeight: 600, width: 450 }}>
            { dashboards && dashboards.map((dashboard, index) => {
              return (
                <ListItemButton key={`dashboard-${index}`}  selected={selectedDashboard === dashboard}
                  onClick={() => setSelectedDashboard(dashboard)} onDoubleClick={() => onDoubleClick(dashboard)}>
                  <ListItemIcon><Dashboard sx={{ color: `rgb(${getPalette().rgbColor[dashboard.customConfig.colorIndex ?? 0]})` }} /></ListItemIcon>
                  <ListItemText primary={dashboard.name}/>
                  <div className={"flex-grow-1"}/>
                  {dashboard.owner && <ListItemText primary={`[ ${dashboard.owner} ]`}/>}
                </ListItemButton>
              );
            })
            }
          </List>
        }
      </DialogContent>

      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary" disabled={selectedDashboard === null} startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OpenDashboard;
